import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '~/lib/api';
import type { ProductInput } from '~shared/schemas';

/**
 * Один хук — один ресурс/операция.
 * Queries: useXxx() → useQuery.
 * Mutations: useCreateXxx/useUpdateXxx/... → useMutation + invalidateQueries по нужным ключам.
 */

const KEYS = {
  all: ['products'] as const,
};

export function useProducts() {
  return useQuery({
    queryKey: KEYS.all,
    queryFn: api.products.list,
  });
}

export function useCreateProduct() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: ProductInput) => api.products.create(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEYS.all });
    },
  });
}

export function useUpdateProduct() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: number; input: ProductInput }) => api.products.update(id, input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEYS.all });
    },
  });
}

export function useDeleteProduct() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.products.delete(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEYS.all });
    },
  });
}
